import React from "react";
import { cn } from "./cn";

type Tone = "neutral" | "brand" | "muted";
type Size = "sm" | "md";

type Props = React.HTMLAttributes<HTMLSpanElement> & {
  tone?: Tone;
  size?: Size;
  leadingIcon?: React.ReactNode;
};

const tones: Record<Tone, string> = {
  neutral: "bg-white text-gray-700 border border-gray-200",
  brand: "bg-brand/10 text-brand border border-brand/20",
  muted: "bg-gray-100 text-gray-600 border border-transparent",
};

const sizes: Record<Size, string> = {
  sm: "h-5 px-2 text-[10px] gap-1",
  md: "h-6 px-2.5 text-[11px] gap-1.5",
};

const Badge: React.FC<Props> = ({
  tone = "neutral",
  size = "sm",
  leadingIcon,
  className,
  children,
  ...rest
}) => (
  <span
    className={cn(
      "inline-flex items-center rounded-full font-semibold tracking-tight",
      tones[tone],
      sizes[size],
      className,
    )}
    {...rest}
  >
    {leadingIcon ? (
      <span className="flex items-center">{leadingIcon}</span>
    ) : null}
    <span className="truncate">{children}</span>
  </span>
);

export default Badge;
